import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  wpuId: yup.number().required(),
  method: yup.string().required(),
  "2fa_resend_token": yup.string().required(),
});

export function useResend2FaOtpMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });
    return http.post(HTTP_ENDPOINTS.send2FaOtp(), req);
  }, options);
}
